import * as Yup from 'yup';

interface ChangPassword {
  senhaAtual: string;
  senha: string;
  newPassword: string;
}

const formulario = async (data: ChangPassword) => {
  const schema = Yup.object().shape({
    senhaAtual: Yup
      .string()
      .required('Senha atual é obrigatória'),
    senha: Yup
      .string()
      .min(6, 'A senha deve conter no mínimo 6 caracteres')
      .required('Senha é obrigatória'),
    newPassword: Yup
      .string()
      .min(6, 'A senha deve conter no mínimo 6 caracteres')
      .required('Nova senha é obrigatória'),
  });

  await schema.validate(data, {
    abortEarly: false,
  });
};

export default {
  formulario,
};
